import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles((theme) => ({
  unifiedListWrapper: {
    width: '100%',
    borderRadius: '12px',
    border: `1px solid ${theme.palette.divider}`,
    overflowX: 'auto',
    overflowY: 'hidden',
    boxShadow: theme.shadows[1], // shadow-sm
    backgroundColor: theme.palette.background.paper,
    marginTop: theme.spacing(1.2),
    marginBottom: theme.spacing(1.2),
    '& > :last-child': {
      borderBottom: 'none !important',
    },
    '& > div > :last-child': {
      borderBottom: 'none !important',
    },
  },
  objetoGridItem: {
    display: 'flex',
    marginTop: '10px',
    marginBottom: '10px',
    '& > *': {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
    },
    '& .MuiCard-root': {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      // Removemos borderRadius e boxShadow pois agora vêm dinamicamente do override Global!
      transition: 'all 0.2s ease-in-out',
      '&:hover': {
        transform: 'translateY(-4px)',
        boxShadow: theme.shadows[3], // shadow-lg do Design System
      },
    },
    '& .MuiPaper-root': {
      height: '100%',
    },
    '& .MuiCardActionArea-root': {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'stretch',
      justifyContent: 'flex-start',
      height: '100%',
    },
    '& .MuiButtonBase-root': {
      height: '100%',
    },

    '& .MuiCardHeader-title p, & .MuiCardHeader-title span': {
      fontWeight: 800, // Restaurado para o impacto original
      color: theme.palette.primary.main,
      fontSize: '0.9rem',
    },
  },
  // NOVAS CLASSES PARA RowObjeto (UNIFICAÇÃO SSoT)
  rowRoot: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(1, 3), // 8px 24px
    borderBottom: `1px solid ${theme.palette.divider}`,
    width: '100%',
    minWidth: '900px',
    cursor: 'pointer',
    transition: 'all 0.15s ease',
    backgroundColor: theme.palette.background.paper,
    '&:hover': {
      backgroundColor: theme.palette.background.default,
    },
  },
  rowAvatar: {
    backgroundColor: 'rgba(26, 35, 126, 0.08)', // Derivado semi-opaco suave de primary.main
    color: theme.palette.primary.main,
    marginRight: theme.spacing(1.5),
    width: '32px',
    height: '32px',
  },
  rowTypeTitle: {
    fontWeight: 800,
    color: theme.palette.primary.main,
    fontSize: '0.75rem',
  },
  rowFieldLabel: {
    display: 'block',
    fontSize: '0.6rem',
    fontWeight: 700,
    color: theme.palette.text.secondary,
    textTransform: 'uppercase',
    letterSpacing: '0.4px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  rowFieldValue: {
    fontSize: '0.725rem',
    fontWeight: 600,
    color: theme.palette.text.secondary, // Vinculado ao token secundário para igualar aos cards
    marginTop: '1px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  // ESTILOS PARA O SKELETON COMPATÍVEL COM O DESIGN SYSTEM
  skeletonRow: {
    padding: theme.spacing(2, 3), // 16px 24px
    borderBottom: `1px solid ${theme.palette.divider}`,
    width: '100%',
    minWidth: '900px',
  },
  skeletonCard: {
    borderRadius: '16px', // Mantido coerência com override de Card
    width: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.03)',
    boxShadow: theme.shadows[1],
  },
}))
